<template>
  <div class="footer-container" :class="{ 'footer-fixed': fixed }">
    <div class="footer-content">
      <div class="copyright">
        Copyright © 2025 北京酷炫网络技术股份有限公司 All rights reserved <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
          京ICP备14056088号
        </a>
      </div>
      <!-- <div class="icp-info"> -->
        
        <!-- 如有公安机关备案号，请取消注释并填写 -->
        <!-- <span class="separator">|</span>
        <a href="http://www.beian.gov.cn" target="_blank" rel="noopener noreferrer">
          京公网安备XXXXXXXXXXXX号
        </a> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    fixed: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-container {
  width: 100%;
  background-color: #ffffff;
  // padding: 10px 0;
  text-align: center;
  flex-shrink: 0; // 防止被压缩
  min-height: 30px; // 确保有足够高度显示完整信息
  display: flex;
  align-items: center;
  justify-content: center;
  
  &.footer-fixed {
    // position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }
  
  .footer-content {
    color: #999999;
    font-size: 12px;
    line-height: 1.6;
    margin: 0 auto;
    padding: 0 15px;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    word-wrap: break-word;
    word-break: break-all;
    
    .copyright {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      a {
        color: #999999;
        text-decoration: none;
        transition: color 0.3s;
        
        &:hover {
          color: #3102ff;
          text-decoration: underline;
        }
      }
    }
  }
}

// 当不是固定定位时，添加顶部间距
.footer-container:not(.footer-fixed) {
  // margin-top: 5px;
}
</style>




// WEBPACK FOOTER //
// src/components/assembly/Footer.vue